/**
 * toast — typed wrapper над sonner. ADR-0007 + Sprint 2 P0.
 *
 * Toast = quick feedback после действия пользователя, auto-dismiss.
 * Для system errors с CTA — используй <Banner sticky> или <Notification>.
 *
 * Usage:
 *   import { toast } from '@/components/ui'
 *   toast.success('Скопировано')
 *   toast.error('Не удалось войти', 'Проверь email и пароль')
 *   toast.promise(saveUser(), { loading: 'Сохраняем…', success: 'Сохранено', error: 'Ошибка' })
 */
import { toast as sonnerToast } from 'sonner'

interface ToastOpts {
  description?: string
  duration?: number
  id?: string | number
}

export const toast = {
  success: (title: string, description?: string, opts?: ToastOpts) =>
    sonnerToast.success(title, { description, ...opts }),
  error: (title: string, description?: string, opts?: ToastOpts) =>
    sonnerToast.error(title, { description, duration: 8000, ...opts }),
  info: (title: string, description?: string, opts?: ToastOpts) =>
    sonnerToast.info(title, { description, ...opts }),
  warning: (title: string, description?: string, opts?: ToastOpts) =>
    sonnerToast.warning(title, { description, duration: 6000, ...opts }),
  promise: sonnerToast.promise,
  loading: (title: string, opts?: ToastOpts) => sonnerToast.loading(title, opts),
  dismiss: (id?: string | number) => sonnerToast.dismiss(id),
}
